import cloneDeep from 'lodash/cloneDeep'
import isArray from 'lodash/isArray'
import isEqual from 'lodash/isEqual'

function handler (el, binding) {
  return () => {
    let option = cloneDeep(binding.value)
    if (isArray(option)) {
      option = {images: option}
    } else if (typeof option === 'string') {
      option = {images: [{src: option}]}
    } else {
      option = option || {}
      if (option.src) {
        option = {images: [option]}
      } else {
        option.images = option.images || []
      }
    }
    if (!option.images.length) option.images.push({src: el.src})
    option.images = option.images.map(image => {
      if (typeof image === 'string') image = {src: image}
      image.name = image.name || option.name || ''
      return image
    })
    if (option.index === undefined && option.images.length > 1) {
      let current = option.current || decodeURI(el.src)
      let idx = option.images.findIndex(image => image.src === current)
      option.index = idx > -1 ? idx : 0
    }
    require('./ImgPopInstance').default.open(option)
  }
}

let OPEN_IMG_POP_HANDLER = '_OPEN_IMG_POP_HANDLER'

function bind (el, binding) {
  el.addEventListener('click', el[OPEN_IMG_POP_HANDLER] = handler(el, binding))
}

function unbind (el) {
  require('./ImgPopInstance').default.close()
  el.removeEventListener('click', el[OPEN_IMG_POP_HANDLER])
}

export default {
  name: 'img-pop',
  bind (el, binding) {
    el.classList.add('img-pop')
    unbind(el)
    bind(el, binding)
  },
  update (el, binding) {
    if (isEqual(binding.value, binding.oldValue)) return
    unbind(el)
    bind(el, binding)
  },
  unbind (el) {
    el.classList.remove('img-pop')
    unbind(el)
  },
}



// WEBPACK FOOTER //
// ./src/components/common/img-pop/directive.js